import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectNumberingDatalist, selectNumberingInwardDatalist } from '../../Selectors/TrackSelector/TrackSelector';
import { Grid, Paper } from '@mui/material';
import { fetchNumberingInwardList, fetchNumberingList } from '../../../Store/PHPSlice/Numbering/numberingApi';
import FirmHeaderImg from '../../FieldsComponents/FirmHeaderImg';
import ReactToPrint from 'react-to-print';
import axios from 'axios';
import SOMatOutViewReturn from '../../Sale/View/SOMatOutViewReturn';

const NumbInwView2 = () => {
    const { Id } = useParams();
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formData, setFormData] = useState({
        dt: '',
        empNm: '',
        ordType: '',
        soId: '',
        sono: '',
        totMtr: '',
        challanId: '',
        firmId: '',
        reMemo: ''
    });
    const [soMaterial, setSoMaterial] = useState([]);
    const dispatch = useDispatch();
    const clIssInfo = useSelector(selectNumberingInwardDatalist);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef();
    useEffect(() => {
        // dispatch(fetchNumberingList(Id))
        dispatch(fetchNumberingInwardList(Id));
        fetchMaterialProductionList(Id);
    }, [Id, dispatch]);

    // console.log(clIssInfo);
    useEffect(() => {
        if (clIssInfo?.returnData) {
            const item = clIssInfo.returnData;
            setFormData(prev => ({
                ...prev,
                id: item?.ID,
                dt: item?.dt,
                numMemo: item?.numMemo,
                numInwMemo: item?.numInwMemo,
                ctInwId: item?.ctInwId,
                sono: item?.sono,
                ctMemo: item?.ctMemo,
                empType: item?.empType,
                empNm: item?.empNm,
                itemId: item?.itemId,
                itemNm: item?.itemNm,
                clothNm: item?.clothNm,
                m1Cloth: item?.m1Cloth,
                m2Cloth: item?.m2Cloth,
                m3Cloth: item?.m3Cloth,
                cutTotQty: item?.cutTotQty,
                numIssQty: item?.numIssQty,
                returnqty: item?.returnqty,
                sts: item?.sts,
                firmId: item?.firmId || '',
                reMemo: item?.return_Memo || ''
            }));
        }
    }, [clIssInfo]);

    const fetchMaterialProductionList = async (id) => {
        const departNm = "NUMBERING";
        try {
            const res = await axios.get(`${baseUrl}?apicall=getMaterialProduction_Returndata_departNm_prodInwid&departNm=${departNm}&prod_inw_id=${id}`)
            // console.log(res.data);
            setSoMaterial(res.data?.data || []);
        } catch (error) {
            console.error('error', error);
        }
    };


    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };

    const handleViewClick = (id, info) => {
        window.open(`/ClothIssueLumpsView/${id}-${info}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    // console.log(clIssInfo?.data);

    const qtyArr = clIssInfo?.numberingInfo?.map(i => i.returnQty);
    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1% 0%', width: '100%' }} ref={componentRef}>
                        {formData?.firmId !== '' && <FirmHeaderImg firmId={formData.firmId} />}
                        <h3 className='centered-heading'>Numbering Inward Info - ({formData.numInwMemo})</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '15px' }}>

                            <tbody>
                                <tr>
                                    <td style={{ width: '200px' }}>Employee</td>

                                    <td style={{ width: '30vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.empNm}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Date</td>

                                    <td style={{ padding: '0.2% 1%', width: '150px' }} className='dark-color'>{formData.dt}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Numbering Inw. Memo</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.numInwMemo}</td>
                                    {/* <td style={{ width: '200px' }}>Cutting Return No.</td>

                                    <td style={{ width: '25vw', padding: '0 1.5%' }}>{formData.ctMemo}</td> */}
                                </tr>


                                <tr>
                                    <td style={{ width: '200px' }}>Item</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.itemNm}</td>
                                    <td style={{ width: '200px' }}>Main Cloth</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.clothNm}</td>
                                </tr>

                                <tr>
                                    <td>M1 Cloth</td>

                                    <td>{formData.m1Cloth || '-'}</td>
                                    <td>M2 Cloth</td>

                                    <td>{formData.m2Cloth || '-'}</td>
                                </tr>
                                <tr>
                                    <td>M3 Cloth</td>

                                    <td>{formData.m3Cloth || '-'}</td>

                                    <td>Total Inward Qty.</td>

                                    <td>{formData.returnqty}</td>
                                </tr>


                            </tbody>


                        </table>
                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableHead>
                                    <TableRow className='tbl-row'>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Size</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Return Qty.</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Array.isArray(clIssInfo?.numberingInfo) && clIssInfo.numberingInfo.length > 0 ? (
                                        clIssInfo?.numberingInfo?.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{index + 1}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.size}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.returnQty}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={5} align='center'>No data available</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        {
                            soMaterial.length > 0 &&
                            <div style={{ marginLeft: '5%' }}>
                                <h3>Material Details</h3>
                                <SOMatOutViewReturn array={soMaterial} qtyArr={qtyArr} />
                            </div>
                        }

                    </div>

                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>


                </Paper>
            </Grid>
        </>
    );
};

export default NumbInwView2;
